/**
 * Default home route after login from OTP / signup, by portal (authKind).
 * Member employees always land on /dashboard even if they also have ops/doctor access.
 */
export function getHomePathForAuth(authKind = 'member', roles = {}) {
  if (authKind === 'ops') return '/ops';
  if (authKind === 'doctor') return '/doctor/pending';
  if (authKind === 'member') return '/dashboard';
  return getHomePathForRoles(roles);
}

/**
 * Role-only home (e.g. access-denied fallbacks when authKind is unknown).
 */
export function getHomePathForRoles(roles = {}) {
  if (roles.isOps) return '/ops';
  if (roles.isDoctor) return '/doctor/pending';
  return '/dashboard';
}

function isLoginPath(path) {
  const p = String(path || '');
  return p === '/login' || p.startsWith('/login/');
}

/**
 * Prefer a deep link the user tried to open before login when their portal allows it.
 */
export function getPostLoginPath(roles = {}, fromPath, authKind = 'member') {
  const home = getHomePathForAuth(authKind, roles);
  const from = String(fromPath || '').trim();
  if (!from || isLoginPath(from)) return home;
  if (authKind === 'ops' && from.startsWith('/ops')) return from;
  if (authKind === 'doctor' && from.startsWith('/doctor')) return from;
  if (authKind === 'member' && from.startsWith('/dashboard')) return from;
  return home;
}
